// Offers per page. The list is fully loaded up front, so pagination is purely a
// client-side slice. 8 fills the desktop 4-column grid with 2 tidy rows.
export const PAGE_SIZE = 8;

/** Total number of pages for `count` offers (0 when there are none). */
export const getPageCount = (count: number): number =>
  Math.ceil(count / PAGE_SIZE);

/** The slice of `items` shown on `page` (1-based). */
export const getPageItems = <T>(items: T[], page: number): T[] =>
  items.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
